import React, { useEffect } from "react";
import styled from 'styled-components';
import Footer from "../../components/common/Footer";
import EsMainBanner from "../../components/es/EsMainBanner";
import EsMainList from "../../components/es/EsMainList";
import Header from "../../components/common/header/Header";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderTransferAction, setCurMenuAction } from "../../modules/common/headerModule";
import { isChrome, isIE, isMobileOnly } from 'react-device-detect';
import { useState, useRef } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { LoginPopupStyles } from '../../components/common/popup/LoginPopup';
import LoginPopup from '../../components/common/popup/LoginPopup';
import Modal from 'react-modal';
import EsMainTab from '../../components/es/EsMainTab';
import EsItemsListContainer from '../../containers/es/EsItemListContainer';
import EsItemsDoneListContainer from '../../containers/es/EsItemsDoneListContainer';
import EsItemsListStContainer from '../../containers/es/EsItemsListStContainer';
import EsItemsListBestContainer from '../../containers/es/EsItemsListBestContainer';
import NormalSmallBtn from '../../components/common/button/NormalSmallBtn';
import CheckBtn from '../../components/common/button/CheckBtn';
import EsItemsBeforeListContainer from '../../containers/es/EsItemsBeforeListContainer';
import { groupBy, forEach, remove, concat, findIndex, replace, find } from 'lodash';
import {Waypoint} from 'react-waypoint'; //for scroll spy
import { reqEsItemListAction, resetItemStatus, reqEsItemListIngAction, esitem_check_info, setIngCheckItemAction, setBeforeCheckItemAction
  , setBeforeItemsAction, delEsItemBeforeAction, resetDelResultItemsAction, reqEsItemListBeforeAction, setEsitemCurIdxAction, reqEsItemListStatusAction } from '../../modules/es/esItemModule';
import {Toast, toast} from '../../components/common/noti/Toast';
import { reqEsOrderCodeReset } from '../../modules/od/orderModule';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';
import $ from 'jquery';
import * as CONSTANTS from '../../lib/util/Constants';
import { Link } from 'react-router-dom';

/**
 * 견적 리스트 화면
 */
const EstimateBlock = styled.div`
    width: 100%;
    margin: 0 auto;

    .info-concurrency-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:${isMobileOnly? '12px': '14px'};
      position:relative;
      margin-top: ${isMobileOnly? '6px': '12px'};
    }

    .bottom_blank {
      padding-bottom: 50px;
      background-color: #ececec;
    }
`;

const EstimateHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 4vw;
    `:`
        width: 1176px;
        margin: 0 auto;
    `};
    min-height:${props => props.height2};
    padding-bottom: ${props => props.bottom};
    position:relative;
`;

const EstimateHeadetTitleBlock = styled.div`
    ${isMobileOnly?`
        width: calc(100% - 120px);
        padding-top: 90px;
        padding-bottom: 99px;
    `:`
        width: 870px;
        //margin: 0 auto;
        padding-top: 200px;
        padding-bottom: 80px;
    `};
`;

const EstimateHeaderLineBlock = styled.div`
    display: inline-block;
    position: relative;
`;

const EstimatetHeaderSpanBlock = styled.div`
    ${isMobileOnly?`
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #111111;   
    `:`
    margin-left : 39px;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
    `};
`;

const EstimateHeaderLineSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 18px;  
    `:`
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
    `};

    font-weight: 600; 

    ::after {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 7px;
        height: ${isMobileOnly? '14px': '20px'};
        background-color: #ffe7ad;
        z-index: -1;
    }
`;

const EstimateLoginBlock = styled.div`
    position:absolute;
    ${isMobileOnly?`
    top : 96px;
    right : 1vw;
    width: 120px;
    `:`
    top : 169px;
    right : 52.9px;
    width: 140px;
    `};
    
    text-align: center;
    //overflow: hidden;

   /*  .wave-first {
        {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='none'%3E%3Crect x='0' y='0' width='120' height='120' style='stroke: none; fill: rgb(255,255,0);' /%3E%3Cpath d='M0,24 C20,4 20,44 40,24 C60,4 60,44 80,24 C100,4 100,44 120,24 L120,300 L0,300 Z' style='stroke: none; fill: rgb(255,199,66);'%3E%3C/path%3E%3C/svg%3E");
        animation: wave 20s both infinite linear;}
    }
    .wave-second& {
        {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='none'%3E%3Crect x='0' y='0' width='120' height='120' style='stroke: none; fill: rgb(255,255,0);' /%3E%3Cpath d='M0,48 C20,28 20,68 40,48 C60,28 60,68 80,48 C100,28 100,68 120,48 L120,300 L0,300 Z' style='stroke: none; fill: rgb(255,199,66);'%3E%3C/path%3E%3C/svg%3E");
        animation: wave 20s both infinite linear;}
    } 
    .wave-third {
        {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='none'%3E%3Crect x='0' y='0' width='120' height='120' style='stroke: none; fill: rgb(255,255,0);' /%3E%3Cpath d='M0,72 C20,52 20,92 40,72 C60,52 60,92 80,72 C100,52 100,92 120,72 L120,300 L0,300 Z' style='stroke: none; fill: rgb(255,199,66);'%3E%3C/path%3E%3C/svg%3E");
        animation: wave 20s both infinite linear;}
    }
    .wave-fourth {
        {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='none'%3E%3Crect x='0' y='0' width='120' height='120' style='stroke: none; fill: rgb(255,255,0);' /%3E%3Cpath d='M0,96 C20,76 20,116 40,96 C60,76 60,116 80,96 C100,76 100,116 120,96 L120,300 L0,300 Z' style='stroke: none; fill: rgb(255,199,66);'%3E%3C/path%3E%3C/svg%3E");
        animation: wave 20s both infinite linear;}
    } */

    @keyframes wave {
        0% {
            background-position: left 0px top 0px;
        }
        100% { 
            background-position: left 1500px top 0px;
        }
    }
`;

const EstimateLoginBoxblock = styled.div`
    ${isMobileOnly?`
    width : 90px;
    height : 90px;
    margin-left: 15px;
    `:`
    width : 120px;
    height : 120px;
    margin-left: 10px;
    `};
    
    position:relative;
    border-radius: 50%;
`;

const EstimateLoginBoxblock2 = styled.div`
    ${isMobileOnly?`
    width : 90px;
    height : 90px;
    margin-left: 15px;
    `:`
    width : 120px;
    height : 120px;
    margin-left: 10px;
    `};
    
    position:absolute;
    border-radius: 50%;
    top: 0px;
`;

const EstimateLoginBtnBlock = styled.button`
    ${isMobileOnly?`
    width : 90px;
    height : 90px;
    font-size: 15px;
    font-weight: 400;
    `:`
    width : 120px;
    height : 120px;
    font-size: 22px;
    font-weight: 400;
    `};
    background-color:${props => props.board===false && (props.count > 0 ? '#ffc742' :'#f4f4f4')};// #ffc742;
    border-radius: 50%; 
    
    text-align: center;

    border: ${props => props.board===true && 'solid 1.6px #e7e7e7'};
    
`;

const EstimateEsNumSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 20px;
    font-weight: 500;
    `:`
    font-size: 40px;
    font-weight: 600;
    `};
    
    color: #111111;
`;

const EstimateFiveNumSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 12px;
    font-weight: normal;
    `:`
    font-size: 20px;
    font-weight: 500;
    `};
    
    color: #666666;
    text-align: center;
`;

const TriTest = styled.div`
    position: relative;
    z-index: 100;
   /* ::before, ::after{
    content: "";
    border-top: 1px solid #999;
    border-right: 1px solid #999;
    height: 15px;
    width: 15px;
    position: absolute;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 43.9px;
    left: 124px;
    z-index: 100;
    background-color: #fff;
   
   } */

    width: 10px;
    height: 2px;
    background: #ffffff;

    position: absolute;
    ${isMobileOnly?`
    bottom: -8px;
    right: 13vw;
    `:`
    bottom: -22px;
    right: 17px;
    `};

    :before {
        content: " ";
        display: block;
        width: 10px;
        height: 1px;
        background: #999999;
        -webkit-transform: rotate(56deg);
        -moz-transform: rotate(56deg);
        -ms-transform: rotate(56deg);
        transform: rotate(56deg);
        position: absolute;
        top: -4px;
        right: -3px;
    }
    :after {
        content: " ";
        display: block;
        width: 10px;
        height: 1px;
        background: #999999;
        -webkit-transform: rotate(-56deg);
        -moz-transform: rotate(-56deg);
        -ms-transform: rotate(-56deg);
        transform: rotate(-56deg);
        position: absolute;
        top: -4px;
        right: 2px;
    }

   @keyframes fadeIn {
    1000% {opacity:0;}
    100% {opacity:1;}
    }
    @keyframes fadeOut {
    1000% {opacity:1;}
    100% {opacity:0;}
    }

`;

const InfoPopOverBlock = styled.span`
      .accent {font-weight: bold;}
      
      .fa-question-circle {
          position:relative;
        .info-concurrency {
          display:none; 
          position:absolute;
          background-color:#fff; 
          border:1px solid #999; 
          animation: fadeOut ease 2s;
          right: -23.5px;
          min-width: 408px;
          border-radius: 4px;
          top: 36px;
          //width:100%;
          padding:30px; 
          text-align: left;
          ${isMobileOnly&&`top: 20px; right: 0;`};
          ${isMobileOnly&&`min-width: 78vw; right: 5vw; padding: 15px;`};
          z-index: 99;
            .title {
                font-size: 18px;
                ${isMobileOnly&&`font-size: 16px;`};
                font-weight: 500;
                    ::before {
                        content: '';
                        display: inline-block;
                        width: 24px;
                        height: 30px;
                        margin-right: 10.5px;
                        background: url(/assets/images/icon/cart-info.svg) center center/auto no-repeat;
                        vertical-align: -9px;
                    }
                }
            .lineborder {
                height: 0;
                border-bottom: solid 1px #111111;
                margin-top: 11px;
            }
            .description {
                font-size: 14px;
                font-weight: normal;
                line-height: 1.86;
                color: #33333;
                padding-top: 9.9px;
                letter-spacing: -0.7px;
                .yellowblcok{
                    display: inline-block;
                    position: relative;
                }
                .yelline {
                    background-color: #ffe7ad;
                    /* ::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 100%;
                        left: 0;
                        bottom: 7px;
                        height: 11px;
                        background-color: #ffe7ad;
                        z-index: -1;
                    } */
                }
            }
          }

        .infoview  {
            {display:unset; animation: fadeIn ease 1s;} 
        }

        

        @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
        }
        @keyframes fadeOut {
        0% {opacity:1;}
        100% {opacity:0;}
        }
              
    }

`;

const EstimateHeaderGrayLine = styled.div`
    height: 8px;
    width: 100vw;
    margin-left: -4vw;
    background-color: #ececec;
    border-top: 1px solid #e0e0e0;
`;

const EstimateListContainerBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    margin: 0 auto;
    background-color: #f4f4f4;
    //padding: 20px 0px 50px;
         
    `:`
    width: 100%;
    margin: 0 auto;
    background-color: #f4f4f4;
    padding: 20px 0px 50px;
    `};
`;

const EstimateListBlock = styled.div`
    ${isMobileOnly?`
        margin: 0;
         
    `:`
        width: 1176px;
        margin: 0 auto;
    `};
`;

const EstimateListBeforeBlock = styled.div`
    ${isMobileOnly?`
        margin: 0;
        margin-top: 28px;
         
    `:`
        width: 1176px;
        margin: 0 auto;
        padding-bottom: 60px;
    `};
    position:relative;
    //padding-top: 80px;
    
`;

const EstimateBottomBlock = styled.div`
    
    ${isMobileOnly?`
    margin: 0 4vw;
    margin-top: 40px;
    margin-bottom: 40px;
    `:`
    margin: 0 auto;
    margin-bottom: 0px;
    width: 100%;
    max-width: 1176px;
    `};
    
    background-color: #f4f4f4;
    padding: 30px 24px 30px 20px;
`;

const EstimateBottomtxtBlock = styled.div`
    ${isMobileOnly?`
    line-height: 1.84;
    `:`
    line-height: 1.71;
    `};
    color: #666666;
    font-size: 14px;
    font-weight: normal;
    
    text-align: left;
`;

const EstimateRequestContainerBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    //margin-left: -4vw;
    `:`
    height : 100px;
    width: 100%;
    margin: 0 auto;
    margin-top: 51px;
    `};

    display: ${props => props.display};
    position:relative;
    bottom:0;
    z-index: 10;
`;

const EstimateRequestBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    left: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    `:`
    height : 100px;
    width: 100vw;
    //min-width: 100%;
    right: 0;
    border-top-left-radius: 20px;
    //min-width : 1176px;
    left: 0px;
    `};
    display: block;
    position:fixed;
    bottom:0;
    z-index: 10;
    background-color: #111111;
    z-index:9;

    &.nofixed {
        position:relative;
        //float: right;
        button { font-weight: 600;}
        left: 0px;
  }
`;

const EstimateRequestContentsBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    //margin-left: -4vw;
    `:`
    height : 100px;
    //width: 1176px;
    width: 100vw;
    margin: 0 auto;
    //margin-top: 40px;
    max-width: 1236px;
    `};

    display: ${props => props.display};
    position:relative;
    bottom:0;
    z-index: 10;
`;

const EstimateRequestTotalBlcok = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 33vw;
    line-height: 70px;
    font-size: 14px;
    font-weight: 500;
    `:`
    height : 100px;
    //width: 230px;
    line-height: 100px;
    font-size: 20px;
    font-weight: 600;
    margin-left: 30px;
    `};
    float: left;
    color: #ffffff;
    text-align: center;
`;

const EstimateRequestBtnBlock = styled.button`
    ${isMobileOnly?`
    height : 70px;
    width : 66vw;
    text-align: center;
    float: left;
    `:`
    height : 100px;
    //width : 540px;
    text-align: right;
    padding-right: 30px;
    float: right;
    `};
    
    
    color: #ffc742;
    
`;

const EstimateRequestSpanBlock = styled.span`
    ${isMobileOnly?`
    line-height: 70px;
    font-size: 16px;
    `:`
    line-height: 100px;
    font-size: 20px;
    `};
    position: relative;
    
    font-weight: 500;
    color: #ffc742;
    &:after {
        content: '';
        display: block;
        position: absolute;
        width: 0%;
        left: 0;
        top: 24px;
        height: 1px;
        background-color: #ffc742;
        z-index: -1;
        -webkit-transition: width .2s ease-in;
        -o-transition: width .2s ease-in;
        transition: width .2s ease-in;
    }

    &:hover::after {
        width: 100%;
    }

    &.line::after {
        width: 100%;
    }

`;

const EstimateRequestLineBlock = styled.div`
    ${isMobileOnly?`
    margin-top: 27px;
    `:`
    margin-top: 42px;
    `};
    width: 0;
    height: 16px;
    border-left: solid 1px #999999;
    float: left;
`;

const EstimateRequestWhiteSpanBlock = styled.span`
    ${isMobileOnly?`
    line-height: 70px;
    font-size: 16px;
    `:`
    line-height: 100px;
    font-size: 20px;
    `};
    position: relative;
    
    font-weight: 500;
    color: #ffffff;
    &:after {
        content: '';
        display: block;
        position: absolute;
        width: 0%;
        left: 0;
        top: 24px;
        height: 1px;
        background-color: #ffffff;
        z-index: -1;
        -webkit-transition: width .2s ease-in;
        -o-transition: width .2s ease-in;
        transition: width .2s ease-in;
    }

    &:hover::after {
        width: 100%;
    }

    &.line::after {
        width: 100%;
    }

`;

const EstimateStHeaderBlock = styled.div`
    height: 67px;
    //padding: ${isMobileOnly?"20px 10px 3px":"20px 25px"};
    font-size: 18px;
    font-weight: bold;
    position: relative;
`;

const EstimateStHeaderTitleBlock = styled.div`
    float: left;
    padding: 40px 0 0;
    /* ::after {
      content: '';
      display: inline-block;
      width: 7px;
      height: 11px;
      margin-left: 10px;
      background: url(/assets/images/icon/arrow_right.svg) center center/cover no-repeat;
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    } */
`;

const EstimateStHeaderArrowBlock = styled.div`
    float: right;
    padding-top: 43px;
    font-size: 14px;
    border-bottom: solid 1px;
    font-weight: normal;
`;

const EstimateStHeaderArrowButtonBlock = styled.button`
    width: 36px;
    height: 36px;
    float: left;
    //padding: 25px;
    margin-top: 28px;
    background : url(${props => props.backgroundimage}) center no-repeat;;
`;

const EstimateStHeaderArrowButton2Block = styled.button`
    width: 36px;
    height: 36px;
    float: left;
    //padding: 25px;
    margin-top: 28px;
    background : url(${props => props.backgroundimage}) center no-repeat;;
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
`;

const EstimateListContainer2Block = styled.div`
    ${isMobileOnly?`
        margin-left: 4vw;
        padding-bottom: 40px;
         
    `:`
        width: 1176px;
        margin: 0 auto;
        padding-bottom: 60px;
    `};
    position:relative;
    //padding-top: 80px;
    
`;

const EstimateListBestBlock = styled.div`
    ${isMobileOnly?`
      margin-left: 4vw;
         
    `:`
        width: 1176px;
        margin: 0 auto;
    `};
    position:relative;
    padding-top: 10px;
    //padding-bottom: 60px;
`;

const MAX_CNT = CONSTANTS.MAX_RQST_CNT;

const Estimate = () => {

  const dispatch = useDispatch();
  const [isRequst, setIsRequest] = useState(false);
  const [availCnt, setAvailCnt] = useState(5);

  //const [prodNum, setProdNum] = useState(0);
  const refBlockReq = useRef(null);
  const history = useHistory();
  const [info, setInfo] = useState(false);
  const refInfo = useRef(null);
  const [txtES, setTxtES] = useState(-1);
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const [fromLoginPU, setFromLoginPU] = useState(false);
  // const [waveClassName, setWaveClassName] = useState("wave-none");
  const [waveClassName, setWaveClassName] = useState("neowave-10");
  const [over, setOver] = useState(false);
  //const [curIdx, setCurIdx] = useState(0);
  const [delStatus, setDelStatus] = useState(false);
  const [isFirst, setIsFirst] = useState(true);
  const [esNum, setEsNum] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [delNum, setDelNum] = useState(0);
  const refSlider = useRef(null);
  const refSliderBest = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [isNotEs, setIsNotEs] = useState(true);
  const [isNotOrder, setIsNotOrder] = useState(true);

  const { accessToken, esItems, esItemCheck, nickname, esItemsBefore, esItemCheckBefore, esDelListBeforeResult, curIdx, esItemsStatus} = useSelector(
    ({ userReducer, loadingReducer, esItemsReducer, userProdReducer }) => ({
        accessToken: userReducer.accessToken,
        esItems: esItemsReducer.esItems,
        esItemCheck: esItemsReducer.esItemCheck,
        nickname: userReducer.nickname,
        esItemsBefore: esItemsReducer.esItemsBefore,
        esItemCheckBefore: esItemsReducer.esItemCheckBefore,
        esDelListBeforeResult: esItemsReducer.esDelListBeforeResult,
        curIdx: esItemsReducer.curIdx,
        esItemsStatus: esItemsReducer.esItemsStatus,
    })
);


  // 최소 실행시 Header 관련 처리 추가
  useEffect(() => {
    dispatch(setCurMenuAction('es'));
    dispatch(setHeaderTransferAction(false));
    window.scrollTo(0, 0);

    dispatch(reqEsOrderCodeReset());

    // if (isChrome === false || isMobile) {
    //   alert("어디가구는 크롬 PC 화면에 최적화 되어있습니다.")
    // }
    if (isIE) {
      alert("어디가구는 크롬 브라우저에 최적화되어 있으며, 인터넷 익스플로러에서는 정상적으로 동작하지 않을 수 있음을 양해 부탁드립니다.")
    }

    if(history.action === 'PUSH'){
      dispatch(setEsitemCurIdxAction(0));
    } else {
        if(history && history.location && history.location.state && history.location.state.index !== undefined && history.location.state.index !== null){
          let index = history.location.state.index*1;
          dispatch(setEsitemCurIdxAction(index));
      }
    }

  }, [])

  useEffect(() => {
    // dispatch(reqEsItemListAction()); // 견적정보 get
    if (esItems !== null && esItems !== undefined) {
        const cnt = (MAX_CNT - esItems.length)<0?0:(MAX_CNT - esItems.length)
        try {

            setTxtES(cnt);
            if (esItems[0][0].rqst_status !== '050106') {
                setAvailCnt(cnt)
                let msg = cnt;
                setTxtES(msg)

                setWaveClassName("neowave-"+msg);
                // if(msg%5 === 4) {
                //     setWaveClassName("wave-fourth");
                // } else if(msg === 3) {
                //     setWaveClassName("wave-third");
                // } else if(msg === 2) {
                //     setWaveClassName("wave-second");
                // } else if(msg === 1) {
                //     setWaveClassName("wave-first");
                // } else {
                //     setWaveClassName("wave-none");
                // }
            }

        } catch (e) { }

        if(isFirst) {
          setIsFirst(false);

          let checkInfo = [];
          //Object.assign(checkInfo, prodCartCheckInfo);
          //console.log("esItems = " + JSON.stringify(esItems));
          forEach(esItems, (curobjs, index) => {
              let curobj = curobjs[0];
              if(curobj.rqst_status==="050105"){

                  let info = {};
                  Object.assign(info, esitem_check_info);
                  info.es_rqst_id = curobj.es_rqst_id;
                  info.rqst_status = curobj.rqst_status;
                  info.es_pay_price = curobj.es_pay_price;

                  checkInfo.push(info);
              }

          });
          //console.log("checkinfo = " + JSON.stringify(checkInfo));
          dispatch(setIngCheckItemAction(checkInfo));
        } else {

          let countCom = 0;
          forEach(esItems, (curobjs, index) => {
              let curobj = curobjs[0];
              if(curobj.rqst_status==="050105"){
                countCom++;
              }

          });

          if(countCom === 0) {
            let checkInfo = [];
            dispatch(setIngCheckItemAction(checkInfo));
          }

        }
    }

  }, [esItems])

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
        if (refInfo.current && !refInfo.current.contains(event.target)) {
            setInfo(false);
        }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
    };
}, [refInfo]);

/* useEffect(() => {
  const onScroll = () => {
    if(!isMobileOnly) {
        $('.fixed').css({left: 0 - $(window).scrollLeft()});
        $('.nofixed').css({left: 0 });
    }
  };

  if(!isMobileOnly) {
    $('.fixed').css({left: 0 - $(window).scrollLeft()});
    $('.nofixed').css({left: 0 });
}
  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
}, []); */



useEffect(() => {
  //console.log("esDelListBeforeResult = " + JSON.stringify(esDelListBeforeResult))
  if(esDelListBeforeResult !== null && esDelListBeforeResult !== undefined) {
    if(esDelListBeforeResult.totalcount === 0) {
      setDelStatus(false);
    }

    if(esDelListBeforeResult.code*1 === 200 && esDelListBeforeResult.totalcount > 0) {
      //console.log("esItemsBefore = " + JSON.stringify(esItemsBefore))
        if(esItemsBefore.items.length === 0) {
          //console.log("reqEsItemListBeforeAction")
          dispatch(reqEsItemListBeforeAction("0"));
        }
    }
    dispatch(resetDelResultItemsAction());
  }

}, [esDelListBeforeResult, esItemsBefore]);

useEffect(() => {
  if(esItemCheck !== null && esItemCheck !== undefined) {
    let num = esItemCheck.length;
    let price = 0;
    forEach(esItemCheck, (curobj, index) => {
      if(curobj.rqst_status==="050105"){
        price+= curobj.es_pay_price;
      }
    });
    setEsNum(num);
    setTotalPrice(price);
  }

}, [esItemCheck]);

useEffect(() => {
  if(esItemCheckBefore !== null && esItemCheckBefore !== undefined) {
    let num = esItemCheckBefore.length;

    setDelNum(num);
  }

}, [esItemCheckBefore]);

useEffect(() => {
  if(accessToken) {
    if (fromLoginPU) {
      setOpenModalLogin(false);
      history.replace("/es");
    }
      dispatch(reqEsItemListStatusAction());

  }

}, [accessToken]);

useEffect(() => {
  //console.log("esItemsStatus = " + JSON.stringify(esItemsStatus))
  if(esItemsStatus !== null && esItemsStatus !== undefined) {
    if(esItemsStatus.code*1 === 200) {
      if(esItemsStatus.data !== null && esItemsStatus.data !== undefined) {
        if(esItemsStatus.data.length < 1) {
          setIsNotEs(true);
          setIsNotOrder(true);
          dispatch(reqEsItemListIngAction());
        } else {
          setIsNotEs(false);
          setIsNotOrder(true);
          forEach(esItemsStatus.data, (curobjs, index) => {
            let rqst_status = curobjs.rqst_status;
            if(rqst_status === '050106') {
              setIsNotOrder(false);
            }

          });

        }
      } else {

      }

    }
  }

}, [esItemsStatus]);

  const handleLogin = () => {
    if (accessToken === null) {
        onOpenModalLogin();
        setFromLoginPU(true);
    }
  }

  const onOpenModalLogin = () => {
      setOpenModalLogin(true);
      //window.location.assign("#loginModal");
  }

  // Modal 닫기
  const onCloseModalLogin = () => {
      setOpenModalLogin(false);
      setFromLoginPU(false);
      //window.history.back();
  }

  const handleEsInfo = () => {
      setInfo(true);
  }

  const handleMouseEnter = () => {
      setOver(true);
  }

  const handleMouseLeave = () => {
      setOver(false);
  }

  const infoConcurrency = () => {return(
      <InfoPopOverBlock>
          <i className="fas fa-question-circle" onClick={handleEsInfo}>
              {(<div className={info ? "info-concurrency infoview" :"info-concurrency"} ref={refInfo}>
                  <div className="title">견적 안내</div>
                  <div className="lineborder"></div>
                  <div className="description">
                        <p>어디가구에서는 과도한 견적 요청을 막고자</p>
                        <p><div className="yellowblcok"><span className="yelline">동시 <span className="accent">견적 브랜드 수량</span>을 <span className="accent">{MAX_CNT}건</span></span></div>으로 제한하고 있습니다.</p>
                        <p>진행중인 견적 중 최소 한 건 이상 완료시</p>
                        <p>새롭게 견적이 가능하오니 이용에 참고 부탁드립니다.</p>
                  </div>
              </div>)}

          </i>
      </InfoPopOverBlock>)
  }

  const infoBlock = () =>{
    return ( <div className="info-concurrency-wrapper">
                <div className="" style={{ display: accessToken === null ? 'none' : 'block',justifyContent:'center', alignItems:'center', color:'#333333' }}>
                <span>나의 견적 횟수 </span>
                    &nbsp;&nbsp;{infoConcurrency()}</div></div>);
  };

  const getLoginBtntext = () => {
    if(accessToken === null) {
        return "로그인"
    } else {
        ////console.log("txtES= "+ txtES)
        if(txtES*1 >= 0) {
            ////console.log("txtES22= "+ txtES)
            return <EstimateEsNumSpanBlock>{txtES}<EstimateFiveNumSpanBlock> / {MAX_CNT}</EstimateFiveNumSpanBlock></EstimateEsNumSpanBlock>
        }
    }
  }

  const getLoginBtnBorder = () => {
      if(accessToken === null) {
          return false;
      } else {
          if(txtES*1 > 0) {
              let count = txtES*1;
              if(count < MAX_CNT && count > 0) {
                  return true;
              }
          }
      }

      return false;
  }

  const getLoginBtnCount = () => {
      if(accessToken === null) {
          return MAX_CNT;
      } else {
          if(txtES*1 > 0) {
              let count = txtES*1;
              if(count <= MAX_CNT && count > 0) {
                  return count;
              }
          }
      }

      return 0;
  }

  const handleBack = () => {
      history.goBack();
  }

  const handleCheckDeleteBtnClick = (value) => {
      setDelStatus(!delStatus);
    // 팝업 표시
    // % 브랜드 % 의 상품들을 모두 삭제하시겠습니까 ?
    /* if(prodCartCheckInfo !== null && prodCartCheckInfo.length > 0) {
        setKind(0);
        setMsg1("");
        setMsg2("선택된 상품들을 삭제하시겠습니까?");
        setMsg3("");
        setOpenModal(true);
    } */
}

  const handleCheckClick = (value) => {

  }

  // 체크 상태 확인
  const getDelCheckStatus = () => {
    return false;
  }

  const handleIngAllCheckClick = (value) => {
    if(value) {
      let checkInfo = [];
      //Object.assign(checkInfo, prodCartCheckInfo);
      ////console.log("esItems = " + JSON.stringify(esItems));
      forEach(esItems, (curobjs, index) => {
          let curobj = curobjs[0];
          if(curobj.rqst_status==="050105"){

              let info = {};
              Object.assign(info, esitem_check_info);
              info.es_rqst_id = curobj.es_rqst_id;
              info.rqst_status = curobj.rqst_status;
              info.es_pay_price = curobj.es_pay_price;

              checkInfo.push(info);
          }

      });
      //console.log("checkinfo = " + JSON.stringify(checkInfo));
      dispatch(setIngCheckItemAction(checkInfo));
    } else {
      let checkInfo = [];
      //console.log("checkinfo = " + JSON.stringify(checkInfo));
      dispatch(setIngCheckItemAction(checkInfo));
    }
  }

  const handlleIngCheckClick = (value) => {
    //console.log("handlleIngCheckClick value = " + value)
    let checkInfo = [];
    Object.assign(checkInfo, esItemCheck);

    let idx = findIndex(checkInfo, (curitem) => {
        return curitem.es_rqst_id === value;
    })

    //console.log('idx = ' + idx)
    //삭제
    if (idx >= 0) {
      remove(checkInfo, (curitem) => {
        return (curitem.es_rqst_id === value);
      })
    } else { //추가
      forEach(esItems, (curobjs, index) => {
        let curobj = curobjs[0];
        if(curobj.es_rqst_id===value){

            let info = {};
            Object.assign(info, esitem_check_info);
            info.es_rqst_id = curobj.es_rqst_id;
            info.rqst_status = curobj.rqst_status;
            info.es_pay_price = curobj.es_pay_price;

            checkInfo.push(info);
        }

      });
    }

    //console.log("checkinfo = " + JSON.stringify(checkInfo));
    dispatch(setIngCheckItemAction(checkInfo));

  }

  const handleBeforeAllCheckClick = (value) => {
    if(esItemsBefore === null || esItemsBefore === undefined || esItemsBefore.items === null) {
      return;
    }

    if(value) {
      let checkInfo = [];
      ////console.log("esItemsBefore = " + JSON.stringify(esItemsBefore))
      forEach(esItemsBefore.items, (curobjs, index) => {
        ////console.log("curobjs = " + JSON.stringify(curobjs))
          let curobj = curobjs[0];
          checkInfo.push(curobj.es_rqst_id);
      });
      //console.log("checkinfo = " + JSON.stringify(checkInfo));
      dispatch(setBeforeCheckItemAction(checkInfo));
    } else {
      let checkInfo = [];
      //console.log("checkinfo = " + JSON.stringify(checkInfo));
      dispatch(setBeforeCheckItemAction(checkInfo));
    }
  }

  const handlleBeforeCheckClick = (value) => {
    //console.log("handlleBeforeCheckClick value = " + value)

    let checkInfo = [];
    Object.assign(checkInfo, esItemCheckBefore);

    let idx = findIndex(checkInfo, (curitem) => {
        return curitem === value;
    })

    //console.log('idx = ' + idx)
    //삭제
    if (idx >= 0) {
      remove(checkInfo, (curitem) => {
        return (curitem === value);
      })
    } else { //추가
      checkInfo.push(value);
    }

    //console.log("checkinfo = " + JSON.stringify(checkInfo));
    dispatch(setBeforeCheckItemAction(checkInfo));

  }

  const handleDeleteBeforeItem = (value) => {
    //console.log("handleDeleteBeforeItem = " + value);
    dispatch(delEsItemBeforeAction(value));
    let _esItems = {};
    Object.assign(_esItems, esItemsBefore);

    //console.log("handleDeleteBeforeItem _esItems = " + JSON.stringify(_esItems));

    remove(_esItems.items, (curitem) => {
      let curobj = curitem[0];
      return (curobj.es_rqst_id === value);
    })

    _esItems.totalcount = _esItems.totalcount -1;
    //console.log("after _esItems = " + JSON.stringify(_esItems));
    dispatch(setBeforeItemsAction(_esItems));

    if(_esItems.totalcount*1 === 0) {
        setTimeout(() => {
          dispatch(reqEsItemListStatusAction());
      }, 1000);
    }
  }

  const handleDeleteChckItems = () => {
    setOpenModal(true);
    /* //console.log("handleDeleteBeforeItem = " + JSON.stringify(esItemCheckBefore));
    dispatch(delEsItemBeforeAction(esItemCheckBefore));
    let _esItems = {};
    Object.assign(_esItems, esItemsBefore);

    //console.log("handleDeleteBeforeItem _esItems = " + JSON.stringify(_esItems));

    remove(_esItems.items, (curitem) => {
      let curobj = curitem[0];
      let idx = findIndex(esItemCheckBefore, (curitem) => {
        return curitem === curobj.es_rqst_id;
      })

      return ( idx>=0 );
    })

    _esItems.totalcount = _esItems.totalcount - esItemCheckBefore.length;
    //console.log("after _esItems = " + JSON.stringify(_esItems));
    dispatch(setBeforeItemsAction(_esItems));

    let checkInfo = [];
    dispatch(setBeforeCheckItemAction(checkInfo)); */
  }

  const handleDeleteChckItemsProcess = () => {
    //console.log("handleDeleteBeforeItem = " + JSON.stringify(esItemCheckBefore));
    dispatch(delEsItemBeforeAction(esItemCheckBefore));
    let _esItems = {};
    Object.assign(_esItems, esItemsBefore);

    //console.log("handleDeleteBeforeItem _esItems = " + JSON.stringify(_esItems));

    remove(_esItems.items, (curitem) => {
      let curobj = curitem[0];
      let idx = findIndex(esItemCheckBefore, (curitem) => {
        return curitem === curobj.es_rqst_id;
      })

      return ( idx>=0 );
    })

    _esItems.totalcount = _esItems.totalcount - esItemCheckBefore.length;
    //console.log("after _esItems = " + JSON.stringify(_esItems));
    dispatch(setBeforeItemsAction(_esItems));

    let checkInfo = [];
    dispatch(setBeforeCheckItemAction(checkInfo));

    if(_esItems.totalcount*1 === 0) {
        setTimeout(() => {
          dispatch(reqEsItemListStatusAction());
      }, 1000);
    }
  }

  const handleDeleteStatus = (value) => {
    //console.log("handleDeleteStatus = " + value)
    if (value === false) {
      let checkInfo = [];
    dispatch(setBeforeCheckItemAction(checkInfo));
    }
    setDelStatus(value);
  }

  const onClickCancel = () => {
    //console.log("onClickCancel = ")
    let checkInfo = [];
    dispatch(setBeforeCheckItemAction(checkInfo));
    setDelStatus(false);
  }

  const handleRequest = () => {
    //console.log("handleRequest")
    let retVal = true;
    let address = "";

    forEach(esItemCheck, (curobj, index) => {

      let esitem = find(esItems, (item)=>{
        let obj = item[0];
        return obj.es_rqst_id === curobj.es_rqst_id;

      })

      if(esitem === null || esitem === undefined) {
        retVal = false;
      } else {
        let item = esitem[0];
        let address1=item.addr1 + item.addr2;
        let address2 = address1.replace(/\n|\t|\r|\s/g, '');

        //console.log("address1 = " + address1)
        //console.log("address2 = " + address2)
        //console.log("address = " + address)
        if(index > 0) {
          if(address2 !== address){
            //console.log("address !== ")
            retVal = false;
          } else {
            //console.log("address === ")
          }
        }

        address=address2;
      }

    });

    //console.log("retVal = " + retVal)

    if(retVal === false) {
        let msg = "죄송합니다. 같은 배송지인 경우에만 일괄주문이 가능합니다.\n같은 배송지인 견적서만 선택해주세요.😉"
        toast('SUCCESS', msg);
        return;
    }

      let es_rqst_id = "";

      forEach(esItemCheck, (curobj, index) => {

        let esitem = find(esItems, (item)=>{
          let obj = item[0];
          return obj.es_rqst_id === curobj.es_rqst_id;

        })

        if(esitem === null || esitem === undefined) {
          retVal = false;
        } else {
          let item = esitem[0];

          if(es_rqst_id==="") {
            es_rqst_id=item.es_rqst_id;
          } else {
            es_rqst_id=es_rqst_id + ","+item.es_rqst_id;
          }
        }

      });

      history.push("/order?reqid=" + es_rqst_id);

      let checkInfo = [];
      //console.log("checkinfo = " + JSON.stringify(checkInfo));
      dispatch(setIngCheckItemAction(checkInfo));
  }

  const handleModalBtn1Click = () => {
      handleDeleteChckItemsProcess();
      setOpenModal(false);
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    const getPopup = () => {
        let msg = "삭제 시 다시 볼 수 없습니다ᅲᅲ\n선택한 견적서를 삭제할까요?";
        return (<NormalPopup
            text={""}
            text2={msg}
            text3={""}
            btn1="삭제" btn2="취소"
            onClick1={handleModalBtn1Click}
            onClick2={handleModalBtn2Click} />)

    }

    const getPopupStyle = () => {
        return customModalStyles;
    }

  const checkBottomPosition = (props) => {
      ////console.log('check = ',JSON.stringify(props))
    if(props.currentPosition === Waypoint.below && refBlockReq.current) {
        ////console.log("nofixed remove")
        //refBlockReq.current.classList.remove('nofixed');
        //refBlockReq.current.classList.add('fixed');
    }
    else if(props.currentPosition === Waypoint.inside && props.previousPosition === Waypoint.below && refBlockReq.current) {
        ////console.log("nofixed add")
        //refBlockReq.current.classList.remove('fixed');
        //refBlockReq.current.classList.add('nofixed');

    }
    ////console.log('check = ',JSON.stringify(refBlockReq.current.classList))

  }

  const handleLeftSlider = () => {
    //console.log("handleLeftSlider")
    if(refSlider && refSlider.current) {
      refSlider.current.slickPrev();
    }
  }

  const handleRightSlider = () => {
    //console.log("handleRightSlider")
    if(refSlider && refSlider.current) {
      refSlider.current.slickNext();
    }
  }

  const handleLeftSliderBest = () => {
    //console.log("handleLeftSliderBest")
    if(refSliderBest && refSliderBest.current) {
      refSliderBest.current.slickPrev();
    }
  }

  const handleRightSliderBest = () => {
    //console.log("handleRightSliderBest")
    if(refSlider && refSliderBest.current) {
      refSliderBest.current.slickNext();
    }
  }

  const getName = () => {
    if(accessToken) {
      return <EstimatetHeaderSpanBlock><EstimateHeaderLineBlock><EstimateHeaderLineSpanBlock>{nickname}</EstimateHeaderLineSpanBlock></EstimateHeaderLineBlock>님, </EstimatetHeaderSpanBlock>
    } else {
      return <EstimatetHeaderSpanBlock><EstimateHeaderLineBlock><EstimateHeaderLineSpanBlock>끄-적</EstimateHeaderLineSpanBlock></EstimateHeaderLineBlock>으로 한번에</EstimatetHeaderSpanBlock>
    }
  }

  const handleTapIndex = (index) => {
    //console.log("handleTapIndex = " + index)
    dispatch(setEsitemCurIdxAction(index));
  }
  return (
    <EstimateBlock>
      <Header />
      {/* {!isMobileOnly&&<EsMainBanner/>} */}
      <EstimateHeaderBlock height2={(isMobileOnly ? (accessToken?'':'240px') : '440px') } bottom={(isMobileOnly ? '' : '0px') } className='clearfix'>
        <EstimateHeadetTitleBlock>
          {getName()}
          <EstimatetHeaderSpanBlock>견적 알아보고 체크하세요!</EstimatetHeaderSpanBlock>
        </EstimateHeadetTitleBlock>
        <EstimateLoginBlock>
                    {/*<EstimateLoginBoxblock2 className={waveClassName+'-2'}> </EstimateLoginBoxblock2>*/}
                    {/*<EstimateLoginBoxblock2 className={waveClassName+'-3'}> </EstimateLoginBoxblock2>*/}
                    <EstimateLoginBoxblock2 className={waveClassName+'-add1'}> </EstimateLoginBoxblock2>
                    <EstimateLoginBoxblock2 className={waveClassName+'-add2'}> </EstimateLoginBoxblock2>
                    <EstimateLoginBoxblock className={waveClassName}><EstimateLoginBtnBlock  onClick={handleLogin} board={getLoginBtnBorder()} count={getLoginBtnCount()}>{getLoginBtntext()}</EstimateLoginBtnBlock> </EstimateLoginBoxblock>

                    <TriTest style={info? {display: "block", animation:"fadeIn ease 1s" }:{display:"none"}}></TriTest>
                    {infoBlock()}

        </EstimateLoginBlock>
        {isMobileOnly&&!accessToken&&<EstimateHeaderGrayLine style={{display:'none', height:"0px"}}/>}
        {accessToken&&!isNotEs?
          (txtES*1 <MAX_CNT?
          <EsMainTab
                            tabList={[{ index: 0, title: "견적서" },
                            { index: 1, title: "주문 완료 견적서" }]}
                            handleTabClick={handleTapIndex} index={curIdx}/>
          :

          !isNotOrder&&<EsMainTab
                            tabList={[{ index: 0, title: "견적서" },
                            { index: 1, title: "주문 완료 견적서" }]}
                            handleTabClick={handleTapIndex} index={curIdx}/>)
        :
          <EstimateStHeaderBlock style={{display:'none', height:"0px"}}>
            <EstimateStHeaderTitleBlock /* onClick={()=>{history.push('/st')}} */>미리 만든 견적서</EstimateStHeaderTitleBlock>
            <EstimateStHeaderArrowBlock><Link to={'/st/'}>전체보기</Link></EstimateStHeaderArrowBlock>
            {/* <EstimateStHeaderArrowBlock style={isMobileOnly? {display: 'none'}:{display: 'none'}}>
                <EstimateStHeaderArrowButtonBlock backgroundimage={'/assets/images/icon/arrow_left.svg'} onClick={handleLeftSlider}/>
                <EstimateStHeaderArrowButton2Block backgroundimage={'/assets/images/icon/arrow_left.svg'} onClick={handleRightSlider}/>
            </EstimateStHeaderArrowBlock> */}
          </EstimateStHeaderBlock>
        }
      </EstimateHeaderBlock>

      {accessToken&&!isNotEs?
        <EstimateListContainerBlock>
        <EstimateListBlock>
          {
            curIdx === 0?
            <EsItemsListContainer curIdx={curIdx} handleIngAllCheckClick={handleIngAllCheckClick} handlleIngCheckClick={handlleIngCheckClick} />
            :
            <EsItemsDoneListContainer curIdx={curIdx} handleIngAllCheckClick={handleIngAllCheckClick} handlleIngCheckClick={handlleIngCheckClick} />
          }

        </EstimateListBlock>
      </EstimateListContainerBlock>
      :
        <EstimateListContainer2Block style={{display:'none', height:"0px"}}>
          {/* <EsItemsListStContainer refSlider={refSlider}/> */}
        </EstimateListContainer2Block>
      }

        {accessToken&&!isNotEs?
        curIdx===0&&<EstimateListBeforeBlock>
          <EsItemsBeforeListContainer curIdx={curIdx} handleBeforeAllCheckClick={handleBeforeAllCheckClick} handlleBeforeCheckClick={handlleBeforeCheckClick}
          handleDeleteBeforeItem={handleDeleteBeforeItem} handleDeleteStatus={handleDeleteStatus} delStatus={delStatus}/>
          </EstimateListBeforeBlock>
        :
        <EstimateListBestBlock>
          {isMobileOnly&&<EstimateHeaderGrayLine/>}
          <EstimateStHeaderBlock>
              <EstimateStHeaderTitleBlock /* onClick={()=>{history.push('/ct/')}} */>먼저 만나보는 베스트 상품</EstimateStHeaderTitleBlock>
              <EstimateStHeaderArrowBlock style={isMobileOnly?{marginRight: '4vw'}:{}}><Link to={'/ct/'}>전체보기</Link></EstimateStHeaderArrowBlock>
              {/* <EstimateStHeaderArrowBlock style={isMobileOnly? {display: 'none'}:{display: 'none'}}>
                  <EstimateStHeaderArrowButtonBlock backgroundimage={'/assets/images/icon/arrow_left.svg'} onClick={handleLeftSliderBest}/>
                  <EstimateStHeaderArrowButton2Block backgroundimage={'/assets/images/icon/arrow_left.svg'} onClick={handleRightSliderBest}/>
              </EstimateStHeaderArrowBlock> */}

            </EstimateStHeaderBlock>
            <EsItemsListBestContainer refSlider={refSliderBest}/>
          </EstimateListBestBlock>
        }

      {
        accessToken&&curIdx===0&&<EstimateBottomBlock>
          <EstimateBottomtxtBlock><span style={{color: '#333333'}}>• 견적서 주문 유효 기간은 견적서를 받은 후 7영업일 이내입니다.</span> 7영업일이 지난 견적서는 주문 기한 만료되어 구매를 하실 수 없습니다.
          </EstimateBottomtxtBlock>
          <EstimateBottomtxtBlock>• 진행중인 견적 요청서는 판매자가 견적을 접수한 상태로 견적 취소가 불가합니다.</EstimateBottomtxtBlock>
      </EstimateBottomBlock>
      }


      {/* <EsMainList /> */}
      <EstimateRequestContainerBlock display={ curIdx ===1 ? 'none' : (esNum > 0 || delStatus) ? 'none' : 'block'  }/>
      <EstimateRequestContainerBlock display={ curIdx ===1 ? 'none' : (esNum > 0 || delStatus) ? 'block' : 'none'  }>

          <EstimateRequestBlock ref={refBlockReq} className="fixed">
              <EstimateRequestContentsBlock>
                {delStatus ? <EstimateRequestTotalBlcok style={{cursor:'pointer'}} onClick={onClickCancel} >취소</EstimateRequestTotalBlcok>
                :<EstimateRequestTotalBlcok >{Number((totalPrice * 1).toFixed(1)).toLocaleString()}<span style={isMobileOnly? {fontSize:'14px', fontWeight:'normal'}:{fontSize:'18px', fontWeight:'normal'}}>원</span></EstimateRequestTotalBlcok>}
                  { isMobileOnly&&<EstimateRequestLineBlock/> }
                  <EstimateRequestBtnBlock onClick={delStatus? handleDeleteChckItems:handleRequest} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    {delStatus ? <EstimateRequestWhiteSpanBlock className={over? "line" : ""}><span style={isMobileOnly ? {fontSize:'18px', fontWeight:'bold'}:{fontSize:'22px', fontWeight:'600'}}>{delNum}</span>개 견적서 삭제하기</EstimateRequestWhiteSpanBlock>
                    :<EstimateRequestSpanBlock className={over? "line" : ""}><span style={isMobileOnly ? {fontSize:'18px', fontWeight:'bold'}:{fontSize:'22px', fontWeight:'600'}}>{esNum}</span>개 견적서 주문하기</EstimateRequestSpanBlock>}
                  </EstimateRequestBtnBlock>
              </EstimateRequestContentsBlock>
          </EstimateRequestBlock>

      </EstimateRequestContainerBlock>
      <Waypoint onPositionChange={(props)=>checkBottomPosition(props)} fireOnRapidScroll></Waypoint>
      <Toast/>
      <Footer siteMovePosition={isMobileOnly?'80px':'110px'} />
      <div className="bottom_blank">&nbsp;</div>
      <Modal
          isOpen={openModalLogin}
          onRequestClose={onCloseModalLogin}
          style={LoginPopupStyles}
          onAfterOpen={() => document.body.style.overflow = 'hidden'}
          onAfterClose={() => document.body.removeAttribute('style')}>
          <LoginPopup onClosePopup={onCloseModalLogin}/>
      </Modal>
      <Modal
          isOpen={openModal}
          onRequestClose={handleModalBtn2Click}
          style={getPopupStyle()}
          onAfterOpen={() => document.body.style.overflow = 'hidden'}
          onAfterClose={() => document.body.removeAttribute('style')}>
          {getPopup()}
      </Modal>
    </EstimateBlock>
  );
};

export default Estimate;
